import { Component } from '@angular/core';
import { UserHelper } from './shared/helpers/user.helper';

@Component({
    selector: 'app-root',
    template: `
    <router-outlet></router-outlet>
  `
})
export class AppComponent {
    constructor(private userHelper: UserHelper) {

        this.userHelper.initUser();

    }
}